//LIBRARIES
import React from 'react';
import styled from 'styled-components';

//HELPERS
import { toFriendlyDateString } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';

//COMPONENTS
import Col from 'components/ui/Col';
import BatchEditing from '../../BatchesPage/BatchEditing';

const ScrollablePanel = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
  width: 100%;
  ${media.ipadMax`
    padding-bottom: 50px;
  `};
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  text-align: center;
  padding: 32px 32px 0;
  max-width: 525px;
  margin: auto;

  ${media.ipadMax`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
  `};
`;

const StyledGreyBox = styled.div`
  background: #f3f3f7;
  border-radius: 16px;
  padding: 15px;
`;

const StyledGreySquare = styled(StyledGreyBox)`
  text-align: center;
  width: 162px;
  height: 156px;

  ${media.ipadMax`
    margin-top: 15px;
    margin-left: 0;
    width: 90%;
  `};
`;

const StyledValue = styled.div`
  font-weight: bold;
  font-size: ${props => props.fontSize || '16px'};
  padding: ${props => props.padding || '0px'};
`;

const StyledCol = styled(Col)`
  ${media.ipadMax`
    margin-bottom: 32px;
  `};
`;

const StyledLabel = styled.div`
  font-size: ${props => props.fontSize || '16px'};
`;

const Overview = ({ batch, updateBatch, onUpdateBatch, deleteBatch }) => {
  return (
    <ScrollablePanel>
      <StyledCol xs={24} sm={24} md={12}>
        <StyledContainer>
          <GreySquare
            value={batch.payments_count}
            label={getTranslatedString('landlordPortal.batches.linkedPayments')}
          />
          <GreySquare
            value={batch.total_amount}
            label={getTranslatedString('landlordPortal.batches.totalBalance')}
            valueFontSize="22px"
            padding="20px 0 21px"
          />
        </StyledContainer>
        <StyledContainer>
          <GreySquare
            value={toFriendlyDateString(batch.post_at) || 'N/A'}
            label={getTranslatedString('landlordPortal.batches.scheduledDate')}
            valueFontSize="22px"
            padding="20px 0 21px"
          />
          <GreySquare
            value={toFriendlyDateString(batch.created_at) || 'N/A'}
            label={getTranslatedString('landlordPortal.maintenance.projects.dateCreated')}
            valueFontSize="22px"
            padding="20px 0 21px"
          />
        </StyledContainer>
      </StyledCol>
      <Col xs={24} sm={24} md={12}>
        <BatchEditing
          selectedBatch={batch}
          deleteBatch={deleteBatch}
          updateBatch={updateBatch}
          onUpdateBatch={onUpdateBatch}
        />
      </Col>
    </ScrollablePanel>
  );
};

const GreySquare = ({ value, label, valueFontSize, padding }) => {
  return (
    <StyledGreySquare>
      <StyledValue padding={padding} fontSize={valueFontSize || '50px'}>
        {value}
      </StyledValue>
      <StyledLabel>{label}</StyledLabel>
    </StyledGreySquare>
  );
};

export default Overview;
